function GenericCard({ children, colorClasses = 'bg-white dark:bg-gray-800' }) {
    return (
        <div className={`p-6 rounded-lg border border-gray-200 shadow-md dark:border-gray-700 ${colorClasses}`}>
            {children}
        </div>
    )
}

export default GenericCard;